import { render } from "./TableColumnHeader.vue?vue&type=template&id=68f834e1"
import script from "./TableColumnHeader.vue?vue&type=script&lang=js"
export * from "./TableColumnHeader.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__